import router from "@/router";

const state = {
  obituaryRegInfo: {
    obituaryMember: []
  },
  obituaryRegFile: [],
  obituaryRegOrder: "first"
};

const getters = {
  getObituaryRegInfo(state) {
    return state.obituaryRegInfo;
  },
  getObituaryRegFile(state) {
    return state.obituaryRegFile;
  },
  getObituaryRegOrder(state) {
    return state.obituaryRegOrder;
  }
};

const mutations = {
  SET_OBITUARY_REG_INFO(state, { obituaryRegInfo, obituaryRegFile }) {
    state.obituaryRegInfo = obituaryRegInfo;
    state.obituaryRegFile = obituaryRegFile;
  },
  SET_OBITUARY_REG_MEMBER(state, { obituaryMember, accountYn }) {
    state.obituaryRegInfo.obituaryMember = obituaryMember;
    state.obituaryRegInfo.accountYn = accountYn;
  },
  SET_OBITUARY_REG_ORDER(state, step) {
    state.obituaryRegOrder = step;
  }
};

const actions = {
  // 부고장 조회
};

export default { mutations, state, actions, getters };
